import { camelCase } from 'lodash/string.js'

export const parseToken = token => {
	if (token == null || token === '') return null
	const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
	const decodedString = decodeURIComponent(atob(base64).split('').map(char => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2)).join(''))
	const obj = JSON.parse(decodedString)
	return Object.keys(obj).reduce((acc, key) => ({ ...acc, [camelCase(key)]: obj[key] }), {})
}
